import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class Home extends withBreakpointObserver(Base) {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Home',
    refs: ['section[]'],
    emits: ['change-navigation'],
    options: {
      inactiveBreakpoints: {
        type: String,
        default: 'xxs xs s m',
      },
    },
  };

  /**
   * Mount Home
   * @returns {void}
   */
  mounted() {
    this.position = 0;
    const observer = new IntersectionObserver(this.checkIntersection.bind(this), {
      treshold: 0,
      rootMargin: '-10% 0% -80% 0%',
    });

    this.$refs.section.forEach((target) => {
      observer.observe(target);
    });
  }

  /**
   * Check message intersection with mobile
   * @param  {object} entries
   * @returns {void}
   */
  checkIntersection(entries) {
    if (entries[0].isIntersecting) {
      const { id } = entries[0].target;
      const target = document.querySelector(`[href='#${id}']`);
      this.$emit('change-navigation', target);
    }
  }
}
